import {Pipe, PipeTransform} from '@angular/core'

@Pipe({
  name: 'replaceString',
  standalone: false,
})
export class HardCodedStringReplacementPipe implements PipeTransform {
  transform(value: string): string {
    const replacements: {[key: string]: string} = {
      // Note: These are to map against contract entries which are wrong.
      // TID is NOT gateway TID etc. But in contracts.. it is.
      tid: 'Gateway TID',
      Tid: 'Gateway TID',
      Mid: 'Acquirer MID',
      mid: 'Acquirer MID',
      ptid: 'Acquirer TID/TID',
      Ptid: 'Acquirer TID/TID',
      // Step 1: Gather your ingredients
      // - 200g spaghetti
      // - 2 tablespoons olive oil
      // - 2 cloves garlic, minced
      // - 400g canned tomatoes (crushed)
      // - Salt and pepper to taste
      // - Fresh basil (optional)
      // - Grated Parmesan cheese (optional)

      // Step 2: Boil water
      // Fill a large pot with water and bring it to a boil. Add a pinch of salt.

      // Step 3: Cook the spaghetti
      // Add the spaghetti to the boiling water and cook according to package instructions (usually 8-10 minutes) until al dente.

      // Step 4: Prepare the sauce
      // While the spaghetti is cooking, heat olive oil in a pan over medium heat.
      // Add minced garlic and sauté for 1-2 minutes until fragrant, being careful not to burn it.

      // Step 5: Add tomatoes
      // Pour in the canned tomatoes. Season with salt and pepper.
      // Let it simmer for about 10 minutes, stirring occasionally.

      // Step 6: Combine spaghetti and sauce
      // Once the spaghetti is cooked, drain it and add it to the sauce.
      // Toss to combine, ensuring the spaghetti is well coated.

      // Step 7: Serve
      // Plate the spaghetti and garnish with fresh basil and grated Parmesan cheese if desired.
    }

    // Return change if possible, else return unchanged value
    return replacements[value] || value
  }
}
